<template>
  <div class="rule-spots-option-wrapper">
    <b-form-group
      class="optimizer-form-group"
      label="Apply Rule To"
      :state="$_hasError('optionInput')"
      :invalid-feedback="$_getError('optionInput')"
    >
      <b-form-radio-group
        class="apply-rule-options"
        v-model="spot"
        :options="options"
        stacked
        name="optionInput"
        data-vv-as="Spots option"
        v-validate="'required'"
      >
      </b-form-radio-group>
    </b-form-group>
  </div>
</template>

<script>
import component from '../mixins/component';

export default {
  name: 'RuleSpot',
  mixins: [component],
  props: {
    value: { type: [Boolean, null], default: null },
  },
  data() {
    return {
      spot: '',
      options: [
        { text: 'Apply to active spots only', value: true },
        { text: 'Apply to all spots (Paused spots will be activated)', value: false },
      ],
    };
  },
  watch: {
    spot: {
      immediate: true,
      handler() {
        this.$_emit('spot');
      },
      deep: true,
    },
  },
  created() {
    this.spot = this.value;
  },
  methods: {
  },
};
</script>

<style lang="scss">
.rule-spots-option-wrapper {
  margin-top: 2.5rem;

  .optimizer-form-group {
    margin-bottom: 0;

    .apply-rule-options {
      display: flex;

      .custom-control-input:checked {
        ~ .custom-control-label::before {
          background-color: $color-light-blue;
          border-color: $color-light-blue;
        }
      }

      .custom-control-label {
        margin-right: 2.5rem;
        font-size: 1.5rem;

        span {
          padding-left: .3rem;
        }

        &::before {
          top: .3rem;
          left: -1.9rem;
          width: 1.5rem;
          height: 1.5rem;
          box-shadow: none;
          outline: none;
        }

        &::after {
          top: 0.3rem;
          left: -1.9rem;
          width: 1.5rem;
          height: 1.5rem;
        }
      }
    }
  }
}
</style>
